import React from "react"
import Img from "gatsby-image"
import {Link} from 'gatsby'

export default function BlogCard({title, author, slug, thumb}) {
    return (
        <Link to={"/blogs/" + slug} key={title}>
            <div className="blog-card">
                <Img fluid={thumb} />
                <div className="blog-card-body">
                <h2>{title}</h2>
                <h4>- {author}</h4>
                </div>
          </div>
        </Link>
    )
  }
  
 